module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGf0b1130b33efeaafe5a4b5a8204fea88.f0b1130b.png";